var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDrinks2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9H2a1,1,0,0,0-1,1v4a9,9,0,0,0,17.941,1H20a3,3,0,0,0,0-6ZM10,21a7.008,7.008,0,0,1-7-7V11H17v3A7.008,7.008,0,0,1,10,21Zm9-8V11c.306.069,2-.366,2,1C21,13.322,19.254,12.943,19,13ZM3.293,6.293l1.25-1.25a2.42,2.42,0,0,1-.6-1.543,2.049,2.049,0,0,1,.6-1.457l.75-.75A1,1,0,0,1,6.707,2.707l-.75.75A2.42,2.42,0,0,1,6.561,5a2.049,2.049,0,0,1-.6,1.457l-1.25,1.25A1,1,0,0,1,3.293,6.293Zm5,0,1.25-1.25a2.42,2.42,0,0,1-.6-1.543,2.049,2.049,0,0,1,.6-1.457l.75-.75a1,1,0,0,1,1.414,1.414l-.75.75A2.42,2.42,0,0,1,11.561,5a2.049,2.049,0,0,1-.6,1.457l-1.25,1.25A1,1,0,0,1,8.293,6.293Zm5,0,1.25-1.25a2.42,2.42,0,0,1-.6-1.543,2.049,2.049,0,0,1,.6-1.457l.75-.75a1,1,0,0,1,1.414,1.414l-.75.75A2.42,2.42,0,0,1,16.561,5a2.049,2.049,0,0,1-.6,1.457l-1.25,1.25a1,1,0,0,1-1.414-1.414Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDrinks2);
export default __webpack_public_path__ + "static/media/sort-drinks2.ca9dce87cc2e6852591d32f2e8519f95.svg";
export { ForwardRef as ReactComponent };